import { render } from "./IngredientFunctions.vue?vue&type=template&id=eafbab5c"
import script from "./IngredientFunctions.vue?vue&type=script&lang=js"
export * from "./IngredientFunctions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"public/themes/default/resources/app/vue/components/AdvancedSearch/IngredientFunctions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "eafbab5c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('eafbab5c', __exports__)) {
    api.reload('eafbab5c', __exports__)
  }
  
  module.hot.accept("./IngredientFunctions.vue?vue&type=template&id=eafbab5c", () => {
    api.rerender('eafbab5c', render)
  })

}


export default __exports__